import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const SuggestChallengeModal = ({ onDismiss, show }) => {
  const { t } = useTranslation();
  return (
    <Modal onDismiss={onDismiss} show={show}>
      <div className="modal-header">
        <h4 className="modal-title">{t('Suggest Challenge')}</h4>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-hidden="true"
          onClick={onDismiss}
        >
          ×
        </button>
      </div>
      <div className="modal-body">
        <p>
          {t(`Use our AI to suggest a new challenge for your game. Our AI will base it's suggestion on
           the challenges currently in your game. Ask it for a suggestion with an empty list and you might get a strange surprise!`)}
        </p>
        <ul>
          <li>
            {t(`Games with stronger core themes, generate better suggestions.`)}
          </li>
          <li>
            {t(`Games with more than 5 existing challenges perform best`)}
          </li>
        </ul>
      </div>
      <div className="modal-footer">
        <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
          {t('Close')}
        </Button>
      </div>
    </Modal>
  )
};

export default SuggestChallengeModal;